export const clickParamsMapping = {"section":5,"row":6,"column":7,"subrow":8,"label":9,"page_type":5,"content_element":6,"content_element_pos":"cep","event_element":7,"event_element_pos":8,"action_type":9,"id":10,"target":"ct"}
